import { AiArtifact, Message } from './message';

export type Conversation = {
    id: string;
    title: string;
    lastMessagePreview: string;
    timestamp: number;
    messages: Message[];
    sessionId?: string;
    artifacts: AiArtifact;
};

export function extractConversationTitle(messages: Message[]): string {
    const firstUserMessage = messages.find(m => m.authorType === 'USER');
    if (!firstUserMessage) return 'Nueva conversación';

    const content = firstUserMessage.content.trim();
    return content.length > 50 ? content.substring(0, 47) + '...' : content;
}

export function extractLastMessagePreview(messages: Message[]): string {
    if (messages.length === 0) return '';

    const lastMessage = messages[messages.length - 1];
    const prefix = lastMessage.authorType === 'USER' ? 'Tú: ' : 'Fin: ';
    const content = lastMessage.content.trim();
    const preview = content.length > 40 ? content.substring(0, 37) + '...' : content;

    return prefix + preview;
}

export function formatRelativeTime(timestamp: number): string {
    const now = Date.now();
    const diff = now - timestamp;

    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Ahora';
    if (minutes < 60) return `${minutes}m`;
    if (hours < 24) return `${hours}h`;
    if (days < 7) return `${days}d`;

    return new Date(timestamp).toLocaleDateString('es-ES', {
        day: 'numeric',
        month: 'short'
    });
}
